import { InputType } from '@import/enums/input-type.enum';
import { ColumnType } from '@import/interfaces';
import { terminationCodeOptions } from '../functions/generate-termination-reason-code-options';

export const JobAndPayTerminationColumnTypes: ColumnType[] = [
    {
        label: 'Last Day Worked On',
        relatedLabels: ['Last Day of Work', 'Last Day'],
        translatableLabel: 'import.columnTypes.lastDayOfWork',
        serializeName: 'lastDayOfWorkOn',
        input: InputType.date,
        required: false,
        requiredWith: ['terminatedOn', 'lastDayOfWorkOn', 'terminationReasonCode'],
    },
    {
        label: 'Terminated On',
        relatedLabels: ['Date Terminated'],
        translatableLabel: 'import.columnTypes.terminatedOn',
        serializeName: 'terminatedOn',
        input: InputType.date,
        required: false,
        requiredWith: ['terminatedOn', 'lastDayOfWorkOn', 'terminationReasonCode'],
    },
    {
        label: 'Termination Reason',
        translatableLabel: 'import.columnTypes.terminationReason',
        serializeName: 'terminationReasonCode',
        input: InputType.options,
        options: [{ label: '', value: null }, ...terminationCodeOptions],
        required: false,
        requiredWith: ['terminatedOn', 'lastDayOfWorkOn', 'terminationReasonCode'],
    },
    {
        label: 'Termination Comment',
        translatableLabel: 'import.columnTypes.terminationComment',
        serializeName: 'terminationComments',
        input: InputType.string,
        required: false,
    },
];
